module.exports = __webpack_public_path__ + "pistolet.png?505bbb08625307f624fc358a9c342576";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pistolet.png
// module id = 115
// module chunks = 0